import React from 'react'
import CustomerFormComponent from './CustomerFormComponent'
import LoginComponent from './LoginComponent'

import AppBar from '@material-ui/core/AppBar'
import Tabs from '@material-ui/core/Tabs'
import Tab from '@material-ui/core/Tab'
import Box from '@material-ui/core/Box'
import styled from 'react-emotion'

import { createMuiTheme, MuiThemeProvider } from '@material-ui/core/styles'

const theme = createMuiTheme({
    palette: {
        primary: {
            main: '#F06F2F'
        },
        secondary: {
            main: '#FFFFFF'
        }
    },
    typography: {
        fontFamily: 'Montserrat, sans-serif',
    }
})

const Wrapper = styled('div')({
    marginTop: 60,
    '@media (max-width: 500px)': {
        marginTop: 40,
    }
})

function TabPanel(props) {
    const { children } = props
    return <Box p={3}>{children}</Box>
}

export default class CustomerComponent extends React.Component {
    constructor(props) {
        super(props)

        this.state = {
            customer: {},
            activeTab: 0
        }

        this.onLogin = this.onLogin.bind(this)
        this.handleTabChange = this.handleTabChange.bind(this)
    }

    onLogin = (customer) => {
        this.setState({
            customer
        })
    }

    handleTabChange = (event, activeTab) => {
        this.setState({
            activeTab
        })
    }

    render() {
        let { customer, activeTab } = this.state
        let { startDate, selectedRoom, onPaymentComplete, config } = this.props
        return (
            <MuiThemeProvider theme={theme}>
                <Wrapper>
                    <AppBar position="static" color="secondary">
                        <Tabs
                            value={activeTab}
                            onChange={this.handleTabChange}
                            indicatorColor="primary"
                            textColor="primary"
                            variant="fullWidth"
                        >
                            <Tab
                                label="Ny kunde"
                                style={{ fontWeight: 'bold', fontSize: '.9em' }}
                            />
                            <Tab
                                label="Eksisterende kunde"
                                style={{ fontWeight: 'bold', fontSize: '.9em' }}
                            />
                        </Tabs>
                    </AppBar>
                    {activeTab === 0 && (
                        <TabPanel>
                            <CustomerFormComponent
                                startDate={startDate}
                                selectedRoom={selectedRoom}
                                onPaymentComplete={onPaymentComplete}
                                config={config}
                            />
                        </TabPanel>
                    )}
                    {activeTab === 1 && (
                        <TabPanel>
                            <LoginComponent
                                onLogin={this.onLogin}
                                customer={customer}
                                startDate={startDate}
                                selectedRoom={selectedRoom}
                                onPaymentComplete={onPaymentComplete}
                            />
                        </TabPanel>
                    )}
                </Wrapper>
            </MuiThemeProvider>
        )
    }
}



// WEBPACK FOOTER //
// ./src/components/CustomerComponent.jsx